import { CircularProgress } from "@material-ui/core";

export default CircularProgress;
